import Switch from 'react-switch';
import styled from 'styled-components';
import { NICE_BG_FOR_CARDS, NICE_BG_FOR_CARDS_HOVER, PRIMARY_COLOR, SECONDARY_TEXT_COLOR } from '../../constants';
import { desktopMediaQuery } from '../../styleHelpers';
import { useGeneralContext } from '../../context/GeneralContextProvider';
import { useModalsContext } from '../../context/ModalsContextProvider';
import { getHasAcceptedTerms } from '../helpers';

const SafeModeToggle = () => {
  const { isSafeMode, handleSafeModeChange } = useGeneralContext();
  const { setShowFirstTimeModal } = useModalsContext();

  const onChange = () => {
    if (isSafeMode) {
      const hasAcceptedTerms = getHasAcceptedTerms();
      if (!hasAcceptedTerms) {
        setShowFirstTimeModal(true);
      }
    }
    handleSafeModeChange(!isSafeMode);
  };

  return (
    <Container>
      <OuterContainer onClick={onChange} role="button" tabIndex={0}>
        <ContentContainer>
          <TitleContainer>
            <IconWrapper>🔞</IconWrapper>
            <TextGroup>
              <TitleText>Safe mode</TitleText>
              <StatusText isEnabled={isSafeMode}>
                {isSafeMode ? 'On (click to disable)' : 'Off'}
              </StatusText>
            </TextGroup>
          </TitleContainer>
          <SwitchStyled
            onChange={onChange}
            checked={isSafeMode}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor="#213e23"
            offColor="#888"
            onHandleColor="#fff"
            offHandleColor="#fff"
            height={24}
            width={48}
          />
        </ContentContainer>
      </OuterContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 500px;
  margin-bottom: 20px;
  margin-top: -8px;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  padding: 16px 20px;
  background: ${NICE_BG_FOR_CARDS};
  border-radius: 12px;
  transition: background 0.2s ease;
  cursor: pointer;
  
  &:focus {
    outline: none;
  }

  ${desktopMediaQuery} {
    &:hover {
      background: ${NICE_BG_FOR_CARDS_HOVER};
    }
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${SECONDARY_TEXT_COLOR};
  font-size: 20px;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const TitleText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${SECONDARY_TEXT_COLOR};
`;

const StatusText = styled.div<{ isEnabled: boolean }>`
  font-size: 13px;
  color: ${({ isEnabled }) => (isEnabled ? 'green' : PRIMARY_COLOR)};
  font-weight: 500;
  opacity: 0.9;
`;

const SwitchStyled = styled(Switch)`
  ${desktopMediaQuery} {
    &:hover {
      cursor: pointer;
    }
  }
`;

export default SafeModeToggle;
